import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { Geolocation } from '@ionic-native/geolocation';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { FCM } from '@ionic-native/fcm';

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { ListPage } from '../pages/list/list';
import { MainPage } from '../pages/main/main';
import { InfoPage } from '../pages/info/info';
import { DatingPage } from '../pages/dating/dating';
import { LinksPage } from '../pages/links/links';
import { UrListPage } from '../pages/ur-list/ur-list';
import { UrAddPage } from '../pages/ur-add/ur-add';
import { JustinfoPage } from '../pages/justinfo/justinfo';
import { MapPage } from '../pages/map/map';
import { MaplistPage } from '../pages/maplist/maplist';
import { MapmodalPage } from '../pages/mapmodal/mapmodal';
import { Card2cardPage } from '../pages/card2card/card2card';

import { ZapisPage } from '../pages/zapis/zapis';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { GlobalsProvider } from '../providers/globals/globals';

import { Device } from '@ionic-native/device';

import { HttpModule } from '@angular/http';

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    ListPage,
    MainPage,
    InfoPage,
    DatingPage,
    LinksPage,
    UrAddPage,
    UrListPage,
    JustinfoPage,
    MapPage,
    MaplistPage,
    MapmodalPage,
    ZapisPage,
    Card2cardPage
  ],
  imports: [
    BrowserModule,
    HttpModule,
    IonicModule.forRoot(MyApp),
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    ListPage,
    MainPage,
    InfoPage,
    DatingPage,
    LinksPage,
    UrAddPage,
    UrListPage,
    JustinfoPage,
    MapPage,
    MaplistPage,
    MapmodalPage,
    ZapisPage,
    Card2cardPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    GlobalsProvider,
    Device,
    Geolocation,
    FCM,
    InAppBrowser
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts